import { ArrowRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { requestService } from "@/lib/nav";

export const About = () => (
  <section id="ueber-uns" className="py-20 lg:py-28 bg-white scroll-mt-20" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <div className="relative rounded-2xl overflow-hidden border border-border shadow-[0_12px_40px_rgb(0,0,0,0.08)] aspect-[4/3]">
          <img
            src="https://images.unsplash.com/photo-1685602728726-76e0340cd1fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
            alt="Heller, aufgeräumter, professionell gereinigter Innenraum"
            loading="lazy" className="w-full h-full object-cover"
          />
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-dark mb-4">Über uns</p>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-charcoal leading-[1.15]">
          Ihr Partner für professionelle Gebäudereinigung in Bremen
        </h2>
        <div className="mt-5 space-y-4 text-lg text-charcoal-muted leading-relaxed">
          <p>
            HANSERA ist Ihr Partner für professionelle Gebäudereinigung in Bremen und Umgebung. Wir
            unterstützen vor allem gewerbliche Auftraggeber – von Arztpraxen und Büros über
            Hausverwaltungen bis zu Gewerbe- und Wohnobjekten – mit zuverlässiger Reinigung, ob
            regelmäßig als Unterhaltsreinigung oder als Einzelauftrag.
          </p>
          <p>
            Ergänzend bieten wir Objektpflege sowie ausgewählte Ausbauleistungen wie Trockenbau- und
            Innenausbauarbeiten an. Uns sind eine klare Kommunikation, eine sorgfältige Planung und
            eine zuverlässige Ausführung wichtig – der vereinbarte Leistungsumfang wird transparent
            im Angebot festgehalten.
          </p>
        </div>
        <button onClick={() => requestService("")} data-testid="about-cta" className="mt-8 inline-flex items-center gap-2 rounded-md bg-forest px-6 py-3 text-white font-semibold hover:bg-forest-dark hover:-translate-y-0.5 transition-[transform,background-color] duration-200">
          Kostenloses Angebot anfordern <ArrowRight className="w-4 h-4" />
        </button>
      </Reveal>
    </div>
  </section>
);
